import { render, staticRenderFns } from "./LimitedPartnerContacts.vue?vue&type=template&id=2dbea1ce"
import script from "./LimitedPartnerContacts.vue?vue&type=script&lang=js"
export * from "./LimitedPartnerContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports